// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annotationLayer section {
  border: none!important;
  z-index: 30;
}
.annotationLayer .linkAnnotation > a:hover {
  background: none;
  box-shadow: none;
}
.textLayer {
  position: absolute;
  text-align: initial;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  line-height: 1;
  text-size-adjust: none;
}
.textLayer span,
.textLayer br {
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}
/* Only necessary in Google Chrome, see issue 14205, and most unfortunately
   * the problem doesn't show up in "text" reference tests. */
.textLayer span.markedContent {
  top: 0;
  height: 0;
}
.textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: #b400aa;
  border-radius: 4px;
}
.textLayer .highlight.appended {
  position: initial;
}
.textLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
.textLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
.textLayer .highlight.middle {
  border-radius: 0;
}
.textLayer .highlight.selected {
  background-color: #006400;
}
/* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
.textLayer br::selection {
  background: transparent;
}
.textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  bottom: 0;
  z-index: -1;
  cursor: default;
  user-select: none;
}
.textLayer .endOfContent.active {
  top: 0;
}
.pdf-reader__page {
  background: #ffffff center center / cover no-repeat;
  margin: 24px;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.2);
  flex: 1 0 auto;
  position: relative;
}
.pdf-reader__overlay {
  position: absolute;
}
.pdf-reader__overlay-bounding-box {
  position: absolute;
  z-index: 40;
}
.pdf-reader__overlay-bounding-box-highlighted {
  background-color: #1857B6;
  mix-blend-mode: screen;
}
.pdf-reader__overlay-bounding-box-highlighted:hover {
  cursor: pointer;
}
.pdf-reader__overlay-bounding-box-highlighted:hover,
.pdf-reader__overlay-bounding-box-highlighted.selected {
  background-color: #5492EF;
  mix-blend-mode: screen;
}
.pdf-reader__overlay-bounding-box-underline {
  pointer-events: none;
  position: absolute;
  z-index: 40;
}
.pdf-reader__overlay-bounding-box-underline.rotate0 {
  border-bottom: 2px dotted #1857B6;
}
.pdf-reader__overlay-bounding-box-underline.rotate90 {
  border-left: 2px dotted #1857B6;
}
.pdf-reader__overlay-bounding-box-underline.rotate180 {
  border-top: 2px dotted #1857B6;
}
.pdf-reader__overlay-bounding-box-underline.rotate270 {
  border-right: 2px dotted #1857B6;
}
.pdf-reader__is-building-page-image {
  outline: 2px solid #F4D35E;
}
.pdf-reader__page--render-type-single-canvas.pdf-reader__page--no-page-image .react-pdf__Page__textContent {
  color: initial;
}
.pdf-reader__page--render-type-multi-canvas .react-pdf__Page .react-pdf__Page__canvas {
  z-index: 10;
}
.pdf-reader__page--render-type-multi-canvas.pdf-reader__page--no-page-image .react-pdf__Page__textContent {
  color: transparent;
}
.pdf-reader__page--is-loading-image {
  left: 50%;
  margin: 0 auto;
  position: absolute;
  transform: translateX(-50%);
  z-index: 50;
}
.pdf-reader__page--is-loading-image .reader__page--is-loading-image-content {
  background-color: #F4D35E;
  height: 24px;
  padding: 0px 12px;
  text-align: center;
  top: 0;
  width: 125px;
}
.pdf-reader__page--has-page-image .textLayer {
  color: transparent;
  z-index: 20;
}
.pdf-reader__page-highlight-overlay {
  pointer-events: none;
  position: absolute;
  z-index: 40;
}
.pdf-reader__page__outline-target {
  position: absolute;
  visibility: hidden;
}
.react-pdf__Page {
  height: 100%;
}
.react-pdf__Page__textContent > span {
  height: 0em!important;
}
.pdf-reader__download-btn,
.pdf-reader__print-btn {
  align-items: center;
  display: flex;
}
.pdf-reader__page-number-control__current-page[type="number"] {
  border-radius: 3px;
  height: 24px;
  -moz-appearance: textfield;
  text-align: center;
  width: 24px;
}
.pdf-reader__page-number-control__total-pages {
  border: none;
}
.pdf-reader__page-number-control__separator {
  padding: 5px;
}
.pdf-reader__page-number-control__current-page::-webkit-inner-spin-button,
.pdf-reader__page-number-control__current-page::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
.pdf-reader__thumbnail {
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
  cursor: pointer;
  min-height: 250px;
  opacity: 0.5;
  transition: opacity 400ms ease-in-out;
  width: 100%;
}
.pdf-reader__thumbnail.pdf-reader__thumbnail--no-image {
  background-color: rgba(0, 0, 0, 0.1);
}
.pdf-reader__thumbnail:hover {
  opacity: 0.75;
  transition-duration: 75ms;
}
.pdf-reader__thumbnail.pdf-reader__thumbnail--is-visible {
  opacity: 1;
  transition-duration: 200ms;
}
.pdf-reader__thumbnail-list {
  list-style: none;
}
.pdf-reader__thumbnail {
  display: inline-block;
}
.pdf-reader__thumbnail-image {
  width: 100%;
}
.reader__thumbnail-list__item:nth-of-type(n + 1) {
  margin-top: 16px;
}
.pdf-reader__side-panel {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.pdf-reader__side-panel.pdf-reader__side-panel--hidden {
  display: none;
}
.pdf-reader__side-panel .pdf-reader__resize-zone {
  height: 100%;
  position: absolute;
  width: 15px;
}
.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--right {
  right: 0;
}
.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--right .pdf-reader__drag-handle {
  right: -9px;
}
.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--right .pdf-reader__drag-handle__assistive-input {
  right: -36px;
}
.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--left {
  left: 0;
}
.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--left .pdf-reader__drag-handle {
  left: -9px;
}
.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--left .pdf-reader__drag-handle__assistive-input {
  left: -36px;
}
.pdf-reader__side-panel .pdf-reader__resize-zone:hover .pdf-reader__drag-handle {
  opacity: 1;
  transition: opacity 100ms ease-in, transform 100ms ease-in-out;
}
.pdf-reader__side-panel .pdf-reader__resize-zone:hover .pdf-reader__drag-handle__assistive-input {
  opacity: 1;
  transition: opacity 200ms ease-in-out, transform 50ms ease-in-out;
}
.pdf-reader__side-panel .pdf-reader__drag-handle {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #d9dadb;
  border-radius: 12px;
  cursor: col-resize;
  display: flex;
  height: 72px;
  justify-content: center;
  opacity: 0;
  position: absolute;
  top: calc(50% - 36px);
  width: 18px;
}
.pdf-reader__side-panel .pdf-reader__drag-handle .pdf-reader__drag-handle__inner {
  background-color: #d9dadb;
  border-radius: 6px;
  height: 30px;
  width: 5px;
}
.pdf-reader__side-panel .pdf-reader__drag-handle__assistive-input {
  direction: rtl;
  height: 0px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(90deg);
  width: 72px;
}
.pdf-reader__side-panel .pdf-reader__drag-handle__assistive-input:focus + .pdf-reader__drag-handle {
  opacity: 1;
}
.pdf-reader__side-panel .pdf-reader__side-panel-overlay {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.pdf-reader__side-panel .pdf-reader__side-panel-title,
.pdf-reader__side-panel .pdf-reader__side-panel-content,
.pdf-reader__side-panel .pdf-reader__side-panel-footer {
  padding: 5px 12px;
}
.pdf-reader__side-panel .pdf-reader__side-panel-close-button {
  border-radius: 50%;
  margin: 5px;
  position: absolute;
  right: 0px;
}
.pdf-reader__arrow-flag-base {
  color: #2E3743;
}
.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__flag {
  position: absolute;
  z-index: 45;
}
.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__flag .pdf-reader__arrow-flag-base__flag-icon {
  position: absolute;
  fill: #ffffff;
  stroke: #2E3743;
}
.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__flag .pdf-reader__arrow-flag-base__flag-label {
  font-size: 11px;
  font-weight: 300;
}
.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__tail {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #2E3743;
  border-radius: 3px;
}
@media print {
  ::-webkit-scrollbar {
    display: none;
  }
  html,
  body {
    height: auto;
  }
  @page {
    size: auto;
    margin: 0;
    overflow: hidden;
  }
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
  }
  .no-break {
    page-break-before: always;
  }
  .reader__page {
    margin: 0;
  }
  .reader .reader__main {
    margin-top: 0px;
  }
  .reader__header {
    display: none;
  }
  hypothesis-sidebar {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./node_modules/@allenai/pdf-components/pdf-components.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;AACA;6DAC6D;AAC7D;EACE,MAAM;EACN,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA,oEAAoE;AACpE;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,MAAM;AACR;AACA;EACE,mDAAmD;EACnD,YAAY;EACZ,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;AACT;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,8DAA8D;AAChE;AACA;EACE,UAAU;EACV,iEAAiE;AACnE;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;EACA;;IAEE,YAAY;EACd;EACA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;EACA;;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".annotationLayer section {\n  border: none!important;\n  z-index: 30;\n}\n.annotationLayer .linkAnnotation > a:hover {\n  background: none;\n  box-shadow: none;\n}\n.textLayer {\n  position: absolute;\n  text-align: initial;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  line-height: 1;\n  text-size-adjust: none;\n}\n.textLayer span,\n.textLayer br {\n  position: absolute;\n  white-space: pre;\n  cursor: text;\n  transform-origin: 0% 0%;\n}\n/* Only necessary in Google Chrome, see issue 14205, and most unfortunately\n   * the problem doesn't show up in \"text\" reference tests. */\n.textLayer span.markedContent {\n  top: 0;\n  height: 0;\n}\n.textLayer .highlight {\n  margin: -1px;\n  padding: 1px;\n  background-color: #b400aa;\n  border-radius: 4px;\n}\n.textLayer .highlight.appended {\n  position: initial;\n}\n.textLayer .highlight.begin {\n  border-radius: 4px 0 0 4px;\n}\n.textLayer .highlight.end {\n  border-radius: 0 4px 4px 0;\n}\n.textLayer .highlight.middle {\n  border-radius: 0;\n}\n.textLayer .highlight.selected {\n  background-color: #006400;\n}\n/* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */\n.textLayer br::selection {\n  background: transparent;\n}\n.textLayer .endOfContent {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 100%;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  cursor: default;\n  user-select: none;\n}\n.textLayer .endOfContent.active {\n  top: 0;\n}\n.pdf-reader__page {\n  background: #ffffff center center / cover no-repeat;\n  margin: 24px;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.2);\n  flex: 1 0 auto;\n  position: relative;\n}\n.pdf-reader__overlay {\n  position: absolute;\n}\n.pdf-reader__overlay-bounding-box {\n  position: absolute;\n  z-index: 40;\n}\n.pdf-reader__overlay-bounding-box-highlighted {\n  background-color: #1857B6;\n  mix-blend-mode: screen;\n}\n.pdf-reader__overlay-bounding-box-highlighted:hover {\n  cursor: pointer;\n}\n.pdf-reader__overlay-bounding-box-highlighted:hover,\n.pdf-reader__overlay-bounding-box-highlighted.selected {\n  background-color: #5492EF;\n  mix-blend-mode: screen;\n}\n.pdf-reader__overlay-bounding-box-underline {\n  pointer-events: none;\n  position: absolute;\n  z-index: 40;\n}\n.pdf-reader__overlay-bounding-box-underline.rotate0 {\n  border-bottom: 2px dotted #1857B6;\n}\n.pdf-reader__overlay-bounding-box-underline.rotate90 {\n  border-left: 2px dotted #1857B6;\n}\n.pdf-reader__overlay-bounding-box-underline.rotate180 {\n  border-top: 2px dotted #1857B6;\n}\n.pdf-reader__overlay-bounding-box-underline.rotate270 {\n  border-right: 2px dotted #1857B6;\n}\n.pdf-reader__is-building-page-image {\n  outline: 2px solid #F4D35E;\n}\n.pdf-reader__page--render-type-single-canvas.pdf-reader__page--no-page-image .react-pdf__Page__textContent {\n  color: initial;\n}\n.pdf-reader__page--render-type-multi-canvas .react-pdf__Page .react-pdf__Page__canvas {\n  z-index: 10;\n}\n.pdf-reader__page--render-type-multi-canvas.pdf-reader__page--no-page-image .react-pdf__Page__textContent {\n  color: transparent;\n}\n.pdf-reader__page--is-loading-image {\n  left: 50%;\n  margin: 0 auto;\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 50;\n}\n.pdf-reader__page--is-loading-image .reader__page--is-loading-image-content {\n  background-color: #F4D35E;\n  height: 24px;\n  padding: 0px 12px;\n  text-align: center;\n  top: 0;\n  width: 125px;\n}\n.pdf-reader__page--has-page-image .textLayer {\n  color: transparent;\n  z-index: 20;\n}\n.pdf-reader__page-highlight-overlay {\n  pointer-events: none;\n  position: absolute;\n  z-index: 40;\n}\n.pdf-reader__page__outline-target {\n  position: absolute;\n  visibility: hidden;\n}\n.react-pdf__Page {\n  height: 100%;\n}\n.react-pdf__Page__textContent > span {\n  height: 0em!important;\n}\n.pdf-reader__download-btn,\n.pdf-reader__print-btn {\n  align-items: center;\n  display: flex;\n}\n.pdf-reader__page-number-control__current-page[type=\"number\"] {\n  border-radius: 3px;\n  height: 24px;\n  -moz-appearance: textfield;\n  text-align: center;\n  width: 24px;\n}\n.pdf-reader__page-number-control__total-pages {\n  border: none;\n}\n.pdf-reader__page-number-control__separator {\n  padding: 5px;\n}\n.pdf-reader__page-number-control__current-page::-webkit-inner-spin-button,\n.pdf-reader__page-number-control__current-page::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n.pdf-reader__thumbnail {\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);\n  cursor: pointer;\n  min-height: 250px;\n  opacity: 0.5;\n  transition: opacity 400ms ease-in-out;\n  width: 100%;\n}\n.pdf-reader__thumbnail.pdf-reader__thumbnail--no-image {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.pdf-reader__thumbnail:hover {\n  opacity: 0.75;\n  transition-duration: 75ms;\n}\n.pdf-reader__thumbnail.pdf-reader__thumbnail--is-visible {\n  opacity: 1;\n  transition-duration: 200ms;\n}\n.pdf-reader__thumbnail-list {\n  list-style: none;\n}\n.pdf-reader__thumbnail {\n  display: inline-block;\n}\n.pdf-reader__thumbnail-image {\n  width: 100%;\n}\n.reader__thumbnail-list__item:nth-of-type(n + 1) {\n  margin-top: 16px;\n}\n.pdf-reader__side-panel {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n.pdf-reader__side-panel.pdf-reader__side-panel--hidden {\n  display: none;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone {\n  height: 100%;\n  position: absolute;\n  width: 15px;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--right {\n  right: 0;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--right .pdf-reader__drag-handle {\n  right: -9px;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--right .pdf-reader__drag-handle__assistive-input {\n  right: -36px;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--left {\n  left: 0;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--left .pdf-reader__drag-handle {\n  left: -9px;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone.pdf-reader__resize-zone--left .pdf-reader__drag-handle__assistive-input {\n  left: -36px;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone:hover .pdf-reader__drag-handle {\n  opacity: 1;\n  transition: opacity 100ms ease-in, transform 100ms ease-in-out;\n}\n.pdf-reader__side-panel .pdf-reader__resize-zone:hover .pdf-reader__drag-handle__assistive-input {\n  opacity: 1;\n  transition: opacity 200ms ease-in-out, transform 50ms ease-in-out;\n}\n.pdf-reader__side-panel .pdf-reader__drag-handle {\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #d9dadb;\n  border-radius: 12px;\n  cursor: col-resize;\n  display: flex;\n  height: 72px;\n  justify-content: center;\n  opacity: 0;\n  position: absolute;\n  top: calc(50% - 36px);\n  width: 18px;\n}\n.pdf-reader__side-panel .pdf-reader__drag-handle .pdf-reader__drag-handle__inner {\n  background-color: #d9dadb;\n  border-radius: 6px;\n  height: 30px;\n  width: 5px;\n}\n.pdf-reader__side-panel .pdf-reader__drag-handle__assistive-input {\n  direction: rtl;\n  height: 0px;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  transform: rotate(90deg);\n  width: 72px;\n}\n.pdf-reader__side-panel .pdf-reader__drag-handle__assistive-input:focus + .pdf-reader__drag-handle {\n  opacity: 1;\n}\n.pdf-reader__side-panel .pdf-reader__side-panel-overlay {\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.pdf-reader__side-panel .pdf-reader__side-panel-title,\n.pdf-reader__side-panel .pdf-reader__side-panel-content,\n.pdf-reader__side-panel .pdf-reader__side-panel-footer {\n  padding: 5px 12px;\n}\n.pdf-reader__side-panel .pdf-reader__side-panel-close-button {\n  border-radius: 50%;\n  margin: 5px;\n  position: absolute;\n  right: 0px;\n}\n.pdf-reader__arrow-flag-base {\n  color: #2E3743;\n}\n.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__flag {\n  position: absolute;\n  z-index: 45;\n}\n.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__flag .pdf-reader__arrow-flag-base__flag-icon {\n  position: absolute;\n  fill: #ffffff;\n  stroke: #2E3743;\n}\n.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__flag .pdf-reader__arrow-flag-base__flag-label {\n  font-size: 11px;\n  font-weight: 300;\n}\n.pdf-reader__arrow-flag-base .pdf-reader__arrow-flag-base__tail {\n  position: absolute;\n  background-color: #ffffff;\n  border: 1px solid #2E3743;\n  border-radius: 3px;\n}\n@media print {\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  html,\n  body {\n    height: auto;\n  }\n  @page {\n    size: auto;\n    margin: 0;\n    overflow: hidden;\n  }\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  .no-break {\n    page-break-before: always;\n  }\n  .reader__page {\n    margin: 0;\n  }\n  .reader .reader__main {\n    margin-top: 0px;\n  }\n  .reader__header {\n    display: none;\n  }\n  hypothesis-sidebar {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
